import { assetUrl, cwaUrl } from '/configuration';
import { PublishStatus } from '/types';

export enum Asset {
  Attachment = 'attachment',
  Image = 'image',
  Video = 'video',
  VideoCoverImage = 'video-cover-image',
}

export const assetUri = (
  id: string,
  type: Asset,
  publishStatus: PublishStatus,
): string => {
  let assetPath = '';
  if (publishStatus === 'live') {
    if (type === Asset.Attachment) {
      assetPath = 'content_media';
    } else {
      assetPath = 'media';
    }
  } else if (publishStatus === 'preview') {
    assetPath = 'preview_media';
  } else if (publishStatus === 'long_term_preview') {
    assetPath = 'long_term_preview_media';
  } else {
    throw new Error(`Unexpected publishStatus '${publishStatus}'`);
  }

  let uri = '';
  if (type === Asset.Attachment) {
    uri = `${cwaUrl}/${assetPath}/${id}`;
  } else {
    uri = `${assetUrl}/${assetPath}/${type}/${id}`;
  }
  return uri;
};
